import React from 'react';
import { motion } from 'framer-motion';
import { FootprintsIcon, MoonStarIcon, DumbbellIcon } from 'lucide-react';
const extras = [{
  icon: FootprintsIcon,
  title: 'Movimiento Diario',
  description: 'Caminar 20–30 min diarios. Ayuda a la digestión y reduce el estrés.'
}, {
  icon: MoonStarIcon,
  title: 'Descanso Profundo',
  description: 'Dormir 7–9 horas. El cuerpo se repara y desinflama mientras duermes.'
}, {
  icon: DumbbellIcon,
  title: 'Fuerza Ligera',
  description: '2–3 sesiones/semana (sentadillas, ligas, pesas). Mejora la sensibilidad a la insulina.'
}];
export function ExtrasSection() {
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-wellness-sage/20 relative" data-id="element-17">
      <div className="max-w-6xl mx-auto" data-id="element-18">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-19">
          <h2 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-20">
            Extras que Ayudan Mucho
          </h2>
          <p className="text-xl text-wellness-text/80 max-w-2xl mx-auto" data-id="element-21">
            La alimentación es clave, pero estos hábitos potencian los
            resultados antiinflamatorios.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-22">
          {extras.map((extra, index) => {
          const Icon = extra.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.15,
            duration: 0.5
          }} className="bg-wellness-sage/40 rounded-[2rem] p-8 text-center border border-wellness-sage/60 hover:bg-wellness-sage/60 transition-colors duration-300" data-id="element-23">
                <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-white text-wellness-medium shadow-sm mb-6" data-id="element-24">
                  <Icon className="w-8 h-8" data-id="element-25" />
                </div>
                <h3 className="text-2xl font-serif font-semibold text-wellness-primary mb-4" data-id="element-26">
                  {extra.title}
                </h3>
                <p className="text-wellness-text/80 text-lg leading-relaxed" data-id="element-27">
                  {extra.description}
                </p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}